import {
	AdminUsageScopeType,
	UsagePeriodTypeEnum,
	UsagePresetEnum
}                                      from '@app/modules/usage/models/common-usage.model';
import { ReportTypeEnum }              from '@app/modules/usage/models/usage-report.model';
import { UsageBusinessPremisesConfig } from '@app/modules/usage/presets/usage-business-premises-config.model';
import { UsageContractConfig }         from '@app/modules/usage/presets/usage-contract-config.model';
import { UsageCurrentTenantConfig }    from '@app/modules/usage/presets/usage-current-tenant-config.model';
import { UsageDtrConfig }              from '@app/modules/usage/presets/usage-dtr-config.model';
import { UsageGkConfig }               from '@app/modules/usage/presets/usage-gk-config.model';
import { UsageOrganizationConfig }     from '@app/modules/usage/presets/usage-organization-config.model';
import { UsageTenantConfig }           from '@app/modules/usage/presets/usage-tenant-config.model';
import {
	ITabItem,
	ProductEnum
}                                      from '@core/interfaces/common.interfaces';
import { ContentAlignmentEnum }        from '@models/common.model';
import {
	PresetActionConfig,
	PresetContentConfig,
	PresetNavigateBackConfig
}                                      from '@models/preset';
import { DownloadFormatEnum }          from '@shared/components/download-button/download-button.model';
import { IGroupConfig }                from '@shared/components/group/group.model';


// ENUMS ##############################################################

// Interfaces #########################################################
export interface IAdminUsageTabItemConfig {
	scope: AdminUsageScopeType;
	tabItem: ITabItem;
}

// Types ##############################################################
export type UsageConfigTypes =
	UsageBusinessPremisesConfig |
	UsageContractConfig |
	UsageCurrentTenantConfig |
	UsageDtrConfig |
	UsageGkConfig |
	UsageOrganizationConfig |
	UsageTenantConfig;

// MODELS #############################################################
export class UsageBaseConfig {
	// base
	public presetId: UsagePresetEnum = undefined;
	public productId: ProductEnum = undefined;

	// navigation
	public navigateBack?: PresetNavigateBackConfig = undefined;


	// navigation
	public reportConfigs?: UsageReportConfig[] = [];
}

export class UsageReportConfig extends PresetContentConfig {

	// store
	public keepCurrentPeriodCached: boolean = undefined;

	// content
	public currentMonthReportIsSupported: boolean = undefined;
	public contentAlignment: ContentAlignmentEnum = ContentAlignmentEnum.AS_ROWS;
	public description?: PresetContentConfig = undefined;
	public noReportDescription?: PresetContentConfig = undefined;
	public reportExplanationDescription?: PresetContentConfig = undefined;
	public reportType: ReportTypeEnum = undefined;
	public showPageLoader?: boolean = undefined;
	public status?: PresetContentConfig = undefined;
	public statusDescription?: PresetContentConfig = undefined;
	public usagePeriodType: UsagePeriodTypeEnum = undefined;
	public groupConfig?: IGroupConfig = undefined;

	// action
	public downloadFormats: DownloadFormatEnum[] = [];
	public download?: PresetActionConfig = undefined;
	public regenerate?: PresetActionConfig = undefined;
	public request?: PresetActionConfig = undefined;
	public retry?: PresetActionConfig = undefined;

	// i18n
	public labelPathPrefix = '';
	public noReportPathPrefix = '';
	public notRequestedDescriptionPathPrefix = '';
	public reportExplanationDescriptionPathPrefix = '';
	public statusFailedDescriptionPathPrefix = '';
	public statusNotRequestedDescriptionPathPrefix = '';
	public statusProcessingDescriptionPathPrefix = '';
	public statusSubmittedDescriptionPathPrefix = '';
	public statusSuccessDescriptionPathPrefix = '';
}

